<button
  class="floating__button"
  [ngClass]="{
    'floating__button--rounded': rounded
  }"
  [title]="label"
  #buttonElement
>
  <i [ngClass]="icon"></i>
</button>
